import type { Action } from 'redux'

import { TOGGLE_REPORT_BUG_DIALOG } from './constants'

export default function isReportBugDialogOpen(state = false, { type }: Action) {
  switch (type) {
    case TOGGLE_REPORT_BUG_DIALOG:
      return !state

    default:
      return state
  }
}
